/* ==========================================================================
   Instagram bar — assets/instagram-bar.js
   Vanilla JS, no dependencies. Handles:
     - left/right scroll arrows (with disabled state at the ends)
     - muted/looping autoplay of videos as they scroll into view
     - per-card mute/unmute toggle button
   Scoped to elements inside .instagram-bar, so it's safe next to any
   other theme JS and works even if the section appears more than once.
   ========================================================================== */

(function () {
  var prefersReducedMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;

  var MUTED_ICON =
    '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
    '<path d="M11 5L6 9H3v6h3l5 4V5z" fill="currentColor"/>' +
    '<path d="M16 9l5 6M21 9l-5 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
    '</svg>';

  var UNMUTED_ICON =
    '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
    '<path d="M11 5L6 9H3v6h3l5 4V5z" fill="currentColor"/>' +
    '<path d="M15.5 9.5a3.5 3.5 0 010 5M18 7a7 7 0 010 10" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
    '</svg>';

  function initBar(bar) {
    var track = bar.querySelector('.instagram-bar__track');
    var prevBtn = bar.querySelector('.instagram-bar__arrow--prev');
    var nextBtn = bar.querySelector('.instagram-bar__arrow--next');
    var cards = Array.prototype.slice.call(bar.querySelectorAll('.instagram-bar__card'));
    var shouldAutoplay = bar.getAttribute('data-autoplay') === 'true' && !prefersReducedMotion;

    if (!track) return;

    function cardStep() {
      var first = cards[0];
      if (!first) return track.clientWidth;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '12') || 12;
      return first.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });
    }
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();

    // Mute/unmute buttons.
    Array.prototype.forEach.call(bar.querySelectorAll('.instagram-bar__mute-btn'), function (btn) {
      var card = btn.closest('.instagram-bar__card');
      var video = card && card.querySelector('.instagram-bar__video');
      if (!video) return;

      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        video.muted = !video.muted;
        btn.setAttribute('aria-pressed', String(!video.muted));
        btn.innerHTML = video.muted ? MUTED_ICON : UNMUTED_ICON;
      });
    });

    // Autoplay muted videos only while their card is on screen.
    var videos = Array.prototype.slice.call(bar.querySelectorAll('.instagram-bar__video'));
    if (!videos.length) return;

    if (!shouldAutoplay || !('IntersectionObserver' in window)) {
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            var playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(function () {
                /* Autoplay blocked by the browser; poster image stays visible. */
              });
            }
          } else {
            video.pause();
          }
        });
      },
      { root: null, threshold: 0.5 }
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.instagram-bar'), initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
